<script setup lang="ts">
import type { FunctionalComponent } from 'vue'
import type { LucideProps } from 'lucide-vue-next'

interface Props {
  /** Компонент иконки из lucide-vue-next. */
  icon: FunctionalComponent<LucideProps>
  size?: number
}

const { icon, size = 18 } = defineProps<Props>()
</script>

<template>
  <component :is="icon" :size="size" :stroke-width="1.75" aria-hidden="true" />
</template>
